import {
  AppBar,
  Button,
  Card,
  CircularProgress,
  Container,
  Dialog,
  FormControl,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  LinearProgress,
  makeStyles,
  Paper,
  Select,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AuthUserContext, withAuthorization } from "../Session";
import moment from "moment";
import EvaluationManagementForm from "./EvaluationManagementForm";
import { amber, blue, blueGrey, cyan, green, grey, lightBlue, lightGreen, orange, red } from "@material-ui/core/colors";
import { Cancel, CheckCircle, Close, MailRounded } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import UserProfile from "../Profile/UserProfile";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProgramManagementPage = (props) => {
  const { firebase } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const csvLink = useRef();

  const [programs, setPrograms] = useState([]);
  const [program, setProgram] = useState(null);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState(null);
  const [managerData, setManagerData] = useState({});
  const [rescuers, setRescuers] = useState([]);
  const [lastFormation, setLastFormation] = useState("");
  const [notificationDay, setNotificationDay] = useState("");
  const [transitionLastDay, setTransitionLastDay] = useState("");
  const [evaluationModal, setEvaluationModal] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [openProfile, setOpenProfile] = useState(false);
  const [userSelectedUID, setUserSelectedUID] = useState("");
  const [isLoadingCSV, setIsLoadingCSV] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [rescuersCSVData, setRescuersCSVData] = useState("");

  useEffect(() => {
    firebase
      .managerData(firebase.currentUser().uid)
      .once("value")
      .then((snap) => {
        const data = snap.val();
        setManagerData(data);
        setPrograms(
          Object.keys(data.programs).map((p) => ({
            key: p,
            name: data.programs[p].name,
          }))
        );
      });
  }, []);

  useEffect(() => {
    if (!!program) {
      setGroups(
        Object.keys(managerData.programs[program].groups).map((g) => ({
          key: g,
          name: managerData.programs[program].groups[g].name,
        }))
      );
    } else {
      setGroup("");
    }
  }, [program]);

  useEffect(() => {
    if (!!group) {
      setLastFormation(moment(managerData?.programs[program]?.groups[group]?.currentPeriod?.lastFormationDate).format("YYYY / MM / DD"));
      setNotificationDay(moment(managerData?.programs[program]?.groups[group]?.currentPeriod?.reminderDate).format("YYYY / MM / DD"));
      setTransitionLastDay(moment(managerData?.programs[program]?.groups[group]?.currentPeriod?.transitionEnds).format("YYYY / MM / DD"));
      const groupRescuers = managerData?.programs[program]?.groups[group].rescuers;
      if (!!groupRescuers) {
        setRescuers(groupRescuers);
        loadSelectedGroupRescuers(groupRescuers);
      } else {
        setRescuers([]);
        loadSelectedGroupRescuers([]);
      }
    }
  }, [group]);

  const loadSelectedGroupRescuers = async (users) => {
    console.log("🔍 Cargando rescatadores:", users?.length || 0);
    setIsLoadingData(true);

    if (!users || users.length === 0) {
      console.warn("⚠️ Grupo sin rescatadores definidos.");
      setUsersData([]);
      setIsLoadingData(false);
      return;
    }

    let usersData = [];
    let usersCSVData = "Email,Nombre,Apellidos,Comunicaciones comerciales,Idioma de contacto,DNI,Teléfono,Sistema operativo,Formación,Alertas activas,E1,E2,E3\n";

    // 🔹 Usamos Promise.allSettled para evitar que un fallo bloquee el resto
    const results = await Promise.allSettled(
      users.map(async (uid) => {
        try {
          const userSnap = await firebase.userCompletInfo(uid);

          // Usuario eliminado o sin datos
          if (!userSnap || Object.keys(userSnap).length === 0) {
            usersData.push({
              email: "(usuario eliminado)",
              uid,
              ECS1: "-",
              ECS2: "-",
              ECS3: "-",
              start: "-",
              end: "-",
              lfECS1: "-",
              lfECS2: "-",
              lfECS3: "-",
            });
            usersCSVData += `(usuario eliminado),,,,,,,,,,,,\n`;
            return;
          }

          // Usuario válido
          const info = userSnap?.userInfo?.info || {};
          const report = userSnap?.reports?.tests || {};
          const lf = userSnap?.reports?.lastFormation;

          usersData.push({
            email: info.email || "(sin email)",
            uid,
            date: moment(userSnap?.reports?.start).format("YYYY/MM/DD"),
            ECS1: report?.ECS1?.metadata?.evalApproved,
            ECS2: report?.ECS2?.metadata?.evalApproved,
            ECS3: report?.ECS3?.metadata?.evalApproved,
            start: lf ? moment(lf.start).format("YYYY/MM/DD") : "-",
            end: lf ? moment(lf.end).format("YYYY/MM/DD") : "-",
            lfECS1: lf ? lf.tests?.ECS1?.metadata?.evalApproved : "-",
            lfECS2: lf ? lf.tests?.ECS2?.metadata?.evalApproved : "-",
            lfECS3: lf ? lf.tests?.ECS3?.metadata?.evalApproved : "-",
          });

          usersCSVData += `${info.email},${info.name},${info.surname},${info.comunicaciones},${info.comunicationsLang},${info.dni},${info.phone},${info.OS},${report?.ECS1?.metadata?.evalApproved}\n`;
        } catch (err) {
          console.error(`💥 Error al cargar ${uid}:`, err);
          usersData.push({
            email: "(error al cargar)",
            uid,
            ECS1: "-",
            ECS2: "-",
            ECS3: "-",
          });
        }
      })
    );

    console.log(`✅ Finalizado: ${usersData.length}/${users.length} usuarios procesados`);
    setUsersData(usersData);
    setIsLoadingData(false);
    setRescuersCSVData(usersCSVData);
  };

  const resetLog = () => firebase.usersReportLog().remove();

  const RestartFormation = (reminderDate, transitionDate) => {
    /**
     * Cuando el coordinador genere un nuevo periodo de evaluación
     * cerrara el episodio anterior, lo pondra en el registro del usuario
     * y reiniciara la evaluación.
     */

    const now = new Date().getTime();
    const managerRef = firebase.managerData(firebase.currentUser().uid);

    managerRef
      .child(`programs/${program}/groups/${group}/currentPeriod`)
      .once("value")
      .then((snap) => {
        if (!!snap.val()) {
          managerRef.child(`programs/${program}/groups/${group}/periodLog`).push({
            lastFormationDate: snap.val().lastFormationDate,
            reminderDate: snap.val().reminderDate,
            transitionEnds: snap.val().transitionEnds,
          });
        }
        managerRef.child(`programs/${program}/groups/${group}/currentPeriod`).update({
          lastFormationDate: now,
          reminderDate: reminderDate.valueOf(),
          transitionEnds: transitionDate.valueOf(),
        });
      });

    rescuers.forEach((r) => {
      firebase
        .userReport(r)
        .once("value")
        .then((snap) => {
          const rep = snap.val();
          let coursesLog;
          let testLog;
          let start;
          let transitionEnds;
          /** Revisamos las posibles datos que haya en la BD para evitar errores */
          if (!!rep) {
            coursesLog = !!rep.courses ? rep.courses : null;
            testLog = !!rep.tests ? rep.tests : DEFAULT_TEST;
            /** en caso de que no tenga comienzo,
             * se pone a 0 para evitar errores  */
            start = !!rep.start ? rep.start : 0;
            transitionEnds = !!rep.transitionEnds ? rep.transitionEnds : 0;
          } else {
            coursesLog = null;
            testLog = DEFAULT_TEST;
            start = 0;
            transitionEnds = 0;
          }

          const evaluationLog = {
            courses: coursesLog,
            tests: testLog,
            end: now,
            start: start,
            transitionEnds: transitionEnds,
          };

          firebase.userReportLog(snap.key).push(evaluationLog);
          firebase.userReport(snap.key).update({
            courses: null,
            tests: DEFAULT_TEST,
            start: now,
            lastFormation: evaluationLog,
            transitionEnds: transitionDate.valueOf(),
          });
        });
    });
    setEvaluationModal(false);
  };

  const handleOpenProfile = (uid) => {
    setUserSelectedUID(uid);
    setOpenProfile(true);
  };

  return (
    <Container>
      <Grid container spacing={4}>
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Typography variant="h4" color="primary">
            <AuthUserContext.Consumer>{(authUser) => `Programas de ${authUser.displayName}`}</AuthUserContext.Consumer>
          </Typography>
          <Typography variant="h5" color="textSecondary">
            Gestión de programas
          </Typography>
        </Grid>

        <Grid container item xs={12} spacing={4}>
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" className={classes.formControl} fullWidth>
              <InputLabel htmlFor="outlined-age-native-simple">{t("programs")}</InputLabel>
              <Select
                native
                value={program}
                onChange={(e) => {
                  setProgram(e.target.value);
                }}
                label={t("programs")}
                inputProps={{
                  name: t("programs"),
                  id: "outlined-age-native-simple",
                }}
              >
                <option aria-label="None" value="" />
                {programs.map((p) => (
                  <option key={p.key} value={p.key}>
                    {p.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" className={classes.formControl} fullWidth>
              <InputLabel htmlFor="outlined-age-native-simple">{t("groups")}</InputLabel>
              <Select
                native
                value={group}
                onChange={(e) => setGroup(e.target.value)}
                disabled={!program}
                label={t("groups")}
                inputProps={{
                  name: t("groups"),
                  id: "outlined-age-native-simple",
                }}
              >
                <option aria-label="None" value="" />
                {groups.map((g) => (
                  <option key={g.key} value={g.key}>
                    {g.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {isLoadingData && (
            <Grid item xs={12}>
              <LinearProgress />
            </Grid>
          )}
          {!!group && !isLoadingData && (
            <Grid container>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <EvaluationsTimeCard value={lastFormation} text="Última formación Online" colorD={green} colorL={lightGreen} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <EvaluationsTimeCard value={notificationDay} text="Próxima evaluación" colorD={lightBlue} colorL={cyan} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <EvaluationsTimeCard value={transitionLastDay} text="Último dia de transición" colorD={orange} colorL={amber} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <Card style={{ borderRadius: 16, height: "100%" }}>
                    <Grid container alignItems="center" style={{ padding: 16, height: "100%" }}>
                      <Grid item xs={12} container justify="center">
                        <Button
                          size="medium"
                          disabled={!group}
                          onClick={() => {
                            setEvaluationModal(true);
                          }}
                        >
                          nuevo curso
                        </Button>
                      </Grid>
                      <EvaluationManagementForm newEvaluation={RestartFormation} close={() => setEvaluationModal(false)} open={evaluationModal} />
                    </Grid>
                  </Card>
                </Grid>

                <Grid container item xs={12} md={6} sm={6}>
                  <Card style={{ padding: 16, borderRadius: 16 }}>
                    <CSVLink data={rescuersCSVData} filename={`${program}_${group}_${new Date().getTime}`} ref={csvLink} target="_blank">
                      {isLoadingCSV ? <CircularProgress size={40} /> : <Typography>Descargar Datos</Typography>}
                    </CSVLink>
                  </Card>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Card
                  style={{
                    padding: 16,
                    borderRadius: 16,
                  }}
                >
                  <Grid container direction="column" spacing={2}>
                    <Grid item xs={12} container alignItems="center">
                      <MailRounded
                        style={{
                          height: 18,
                          paddingRight: 8,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button onClick={resetLog} disabled>
                        Eliminar Datos
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table" size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell colSpan={4} className={classes.rowBlue}>
                          Resultados Actuales
                        </TableCell>
                        <TableCell colSpan={5} className={classes.rowRed}>
                          Resultados Anteriores
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell className={classes.rowBlue}>Inicio</TableCell>
                        <TableCell className={classes.rowBlue}>E1</TableCell>
                        <TableCell className={classes.rowBlue}>E2</TableCell>
                        <TableCell className={classes.rowBlue}>E3</TableCell>
                        <TableCell className={classes.rowRed}>Inicio</TableCell>
                        <TableCell className={classes.rowRed}>Fin</TableCell>
                        <TableCell className={classes.rowRed}>E1</TableCell>
                        <TableCell className={classes.rowRed}>E2</TableCell>
                        <TableCell className={classes.rowRed}>E3</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {usersData.map((user, k) => (
                        <TableRow
                          className={classes.tableRow}
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpenProfile(user.uid)}
                        >
                          <TableCell align="left">{user.email}</TableCell>
                          <TableCell>{user.date}</TableCell>
                          <TableCell>
                            <EvaluationIcon aproved={user.ECS1} />
                          </TableCell>
                          <TableCell>
                            <EvaluationIcon aproved={user.ECS2} />
                          </TableCell>
                          <TableCell>
                            <EvaluationIcon aproved={user.ECS3} />
                          </TableCell>
                          <TableCell>{user.start}</TableCell>
                          <TableCell>{user.end}</TableCell>
                          <TableCell>
                            <EvaluationIcon aproved={user.lfECS1} />
                          </TableCell>
                          <TableCell>
                            <EvaluationIcon aproved={user.lfECS2} />
                          </TableCell>
                          <TableCell>
                            <EvaluationIcon aproved={user.lfECS3} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Dialog fullScreen open={openProfile} onClose={() => setOpenProfile(false)} TransitionComponent={Transition}>
        <AppBar>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                setOpenProfile(false);
              }}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid style={{ marginTop: 46 }}>
          <UserProfile uid={userSelectedUID} />
        </Grid>
      </Dialog>
    </Container>
  );
};

const EvaluationIcon = ({ aproved }) => (!aproved ? <Cancel style={{ color: red[400] }} /> : <CheckCircle style={{ color: green[400] }} />);

const EvaluationsTimeCard = ({ text, value, colorL, colorD }) => (
  <Card style={{ padding: 16, borderRadius: 16, backgroundColor: colorL[50] }}>
    <Grid container direction="column" spacing={2}>
      <Grid item xs={12} container alignItems="center">
        <MailRounded style={{ height: 18, color: colorD[700], paddingRight: 8 }} />
        <Typography style={{ color: colorD[700] }}>{text}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" color="textPrimary">
          {!!value ? value : "--"}
        </Typography>
      </Grid>
    </Grid>
  </Card>
);
const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(ProgramManagementPage);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  rowBlue: {
    backgroundColor: blue[600],
    color: "white",
  },
  rowRed: {
    backgroundColor: red[600],
    color: "white",
  },
}));

const DEFAULT_TEST = {
  ECS1: {
    metadata: {
      nAttemps: -1,
      studed: false,
      evalApproved: false,
      isOnProgress: false,
    },
  },
  ECS2: {
    metadata: {
      nAttemps: -1,
      studed: false,
      evalApproved: false,
      isOnProgress: false,
    },
  },
  ECS3: {
    metadata: {
      nAttemps: -1,
      studed: false,
      evalApproved: false,
      isOnProgress: false,
    },
  },
  tableRow: {
    background: "blue",
    "&:hover": {
      background: grey[100],
      cursor: "pointer",
    },
  },
};
